import { CSSObject } from "@emotion/react";
import { VStack } from "goi_common";
import React, { PropsWithChildren } from "react";

export default function ClosedSangjoLayout({
  children,
  style,
}: PropsWithChildren<{ style?: CSSObject }>) {
  return (
    <VStack
      css={{
        maxWidth: "480px",
        width: "100%",
        position: "relative",
        margin: "0 auto",
        ...style,
      }}
    >
      {children}
    </VStack>
  );
}
